import React from 'react';
import { Link } from 'react-router-dom';

const RegistrationPending = () => (
  <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl shadow-md max-w-md p-8 text-center">
      <h1 className="text-xl font-semibold text-slate-900">We&apos;ll be in touch</h1>
      <p className="text-slate-600 text-sm mt-3 leading-relaxed">
        Thanks for registering your commercial account. Our team will review your details and
        follow up before your portal access is activated.
      </p>
      <p className="text-slate-500 text-sm mt-4">
        You can try signing in after you receive approval.
      </p>
      <Link
        to="/login"
        className="inline-block mt-6 bg-teal-700 text-white px-5 py-2 rounded-lg text-sm hover:bg-teal-800"
      >
        Back to sign in
      </Link>
    </div>
  </div>
);

export default RegistrationPending;
